
{
  "familyId": "GET-BREUK-LEZEN",
  "questions": [
    {
      "id": "GET-BREUK-LEZEN-001",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je de breuk $\\frac{3}{5}$?",
      "options": [
        "drie vijfde",
        "vijf derde",
        "drie van vijf",
        "drie komma vijf"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_lezen_basis",
      "variantIndex": 1,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.75,
      "feedback": {
        "explanationText": "Strategie: lees eerst de teller (boven), dan de noemer (onder) met '-de' of '-ste' erachter. Stap 1: de teller is 3 → 'drie'. Stap 2: de noemer is 5 → 'vijfde'. Stap 3: samen: 'drie vijfde'. Onthoud: teller = 'hoeveel', noemer = 'welk soort deel'.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{5}$ lees je als 'drie vijfde' — 3 (teller) delen van 5 (noemer).",
          "1": "Veelgemaakte fout: teller en noemer omdraaien. Bij $\\frac{3}{5}$ is 3 de teller (boven) en 5 de noemer (onder). Je leest: 'drie vijfde', niet 'vijf derde'.",
          "2": "Veelgemaakte fout: 'van' gebruiken in plaats van de juiste breuknaam. De wiskundige manier is 'drie vijfde', niet 'drie van vijf'. 'Drie van vijf' klinkt als een score, niet als een breuk.",
          "3": "Veelgemaakte fout: een breuk verwarren met een kommagetal. $\\frac{3}{5}$ is een breuk ('drie vijfde'), niet het kommagetal 3,5 ('drie komma vijf'). $\\frac{3}{5}$ = 0,6 als kommagetal."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-002",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Welke breuk hoort bij 'twee zevende'?",
      "options": [
        "$\\frac{2}{7}$",
        "$\\frac{7}{2}$",
        "$\\frac{2}{9}$",
        "$\\frac{1}{7}$"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_schrijven_basis",
      "variantIndex": 2,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Strategie: het eerste woord is de teller, het tweede woord geeft de noemer. Stap 1: 'twee' → teller = 2. Stap 2: 'zevende' → noemer = 7. Stap 3: schrijf als $\\frac{2}{7}$.",
        "distractorExplanations": {
          "0": "Goed! 'Twee zevende' = teller 2, noemer 7 = $\\frac{2}{7}$.",
          "1": "Veelgemaakte fout: teller en noemer omdraaien. 'Twee zevende' → 2 boven, 7 onder = $\\frac{2}{7}$. Bij $\\frac{7}{2}$ zou je 'zeven halve' zeggen.",
          "2": "Veelgemaakte fout: 'zevende' verwarren met 'negende'. Zevende = 7, negende = 9. Luister goed naar het woord: zeven → zevende.",
          "3": "Veelgemaakte fout: het telwoord verkeerd lezen. 'Twee zevende' heeft teller 2, niet 1. 'Eén zevende' zou $\\frac{1}{7}$ zijn."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-003",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je $\\frac{1}{2}$?",
      "options": [
        "een half",
        "een tweede",
        "twee eerste",
        "een komma twee"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_lezen_bijzonder",
      "variantIndex": 3,
      "citoDifficulty": 0.18,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "Strategie: sommige breuken hebben een speciale naam. Stap 1: $\\frac{1}{2}$ is een bijzondere breuk. Stap 2: we zeggen 'een half' (niet 'een tweede'). Stap 3: andere bijzondere namen: $\\frac{1}{4}$ = 'een kwart', $\\frac{3}{4}$ = 'drie kwart'.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{2}$ lees je als 'een half'. Dit is een bijzondere breuknaam die je moet onthouden.",
          "1": "Bijna goed, maar niet de gebruikelijke naam. Wiskundig klopt 'een tweede', maar in het dagelijks taalgebruik zeggen we 'een half'. Net zoals we 'een kwart' zeggen in plaats van 'een vierde'.",
          "2": "Veelgemaakte fout: teller en noemer omdraaien. Bij $\\frac{1}{2}$ is 1 de teller en 2 de noemer. 'Twee eerste' zou $\\frac{2}{1}$ zijn (= 2 hele).",
          "3": "Veelgemaakte fout: een breuk verwarren met een kommagetal. $\\frac{1}{2}$ = 'een half' = 0,5. Het is niet 'een komma twee' (dat zou 1,2 zijn)."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-004",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Welke breuk hoort bij 'vijf achtste'?",
      "options": [
        "$\\frac{5}{8}$",
        "$\\frac{8}{5}$",
        "$\\frac{5}{3}$",
        "$\\frac{58}{1}$"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_schrijven_basis",
      "variantIndex": 4,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.73,
      "feedback": {
        "explanationText": "Strategie: het eerste woord is de teller, het tweede woord geeft de noemer. Stap 1: 'vijf' → teller = 5. Stap 2: 'achtste' → noemer = 8. Stap 3: schrijf als $\\frac{5}{8}$.",
        "distractorExplanations": {
          "0": "Goed! 'Vijf achtste' = teller 5, noemer 8 = $\\frac{5}{8}$.",
          "1": "Veelgemaakte fout: teller en noemer omdraaien. 'Vijf achtste' → 5 boven, 8 onder. $\\frac{8}{5}$ zou 'acht vijfde' zijn.",
          "2": "Veelgemaakte fout: 'achtste' verwarren met 'derde'. Achtste = 8, derde = 3. Luister goed: acht → achtste.",
          "3": "Veelgemaakte fout: de getallen als één getal lezen. 'Vijf achtste' is een breuk met teller 5 en noemer 8, niet het getal 58."
        }
      }
    },
    {
      "id": "GET-BREUK-LEZEN-005",
      "familyId": "GET-BREUK-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je $\\frac{3}{4}$?",
      "options": [
        "drie kwart",
        "drie vierde",
        "vier derde",
        "driekwart procent"
      ],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "breuk_lezen_bijzonder",
      "variantIndex": 5,
      "citoDifficulty": 0.2,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "Strategie: $\\frac{3}{4}$ is een bijzondere breuk met een speciale naam. Stap 1: noemer 4 → we zeggen 'kwart' (niet 'vierde'). Stap 2: teller 3 → 'drie'. Stap 3: samen: 'drie kwart'. Onthoud: $\\frac{1}{4}$ = een kwart, $\\frac{2}{4}$ = twee kwart (= een half), $\\frac{3}{4}$ = drie kwart.",
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{4}$ lees je als 'drie kwart'. Dit is de gebruikelijke naam voor breuken met noemer 4.",
          "1": "Bijna goed, maar niet de gebruikelijke naam. 'Drie vierde' is wiskundig correct, maar in het Nederlands zeggen we 'drie kwart'. Net zoals we 'een half' zeggen in plaats van 'een tweede'.",
          "2": "Veelgemaakte fout: teller en noemer omdraaien. Bij $\\frac{3}{4}$ is 3 de teller (boven) en 4 de noemer (onder). 'Vier derde' zou $\\frac{4}{3}$ zijn.",
          "3": "Veelgemaakte fout: 'kwart' verwarren met 'procent'. Drie kwart ($\\frac{3}{4}$) = 75%, maar het is geen procent. Een breuk en een percentage zijn verschillende manieren om hetzelfde te schrijven."
        }
      }
    }
  ]
}
